import { useCallback, useEffect, useState } from "react";
import { ScanFace, UserCheck } from "lucide-react";
import { ConfirmDialog } from "@/components/ConfirmDialog";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { EmptyState, PageHeader } from "@/components/common";
import { cn } from "@/lib/utils";

export default function StatusPetugasPage() {
  const [items, setItems] = useState(null);
  const load = useCallback(() => { api.get("/petugas-lapangan", { params: { all: true } }).then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  useEffect(() => { load(); }, [load]);
  const toggle = async (p) => {
    try { await api.patch(`/petugas-lapangan/${p.id}/status`, { active: !p.active }); toast.success(`${p.name} ${p.active ? "dinonaktifkan" : "diaktifkan"}`); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  const [reset, setReset] = useState(null);
  const doReset = async () => {
    try { await api.post(`/petugas-lapangan/${reset.id}/face-reset`); toast.success(`Wajah ${reset.name} direset`); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div>
      <PageHeader title="Status Petugas Lapangan" />
      {items === null ? <p className="text-muted-foreground">Memuat...</p> : items.length === 0 ? <EmptyState icon={UserCheck} title="Belum ada petugas lapangan" testId="status-petugas-empty" /> : (
        <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-4 gap-4">
          {items.map((p) => (
            <div key={p.id} className={cn("rounded-2xl text-white shadow-sm overflow-hidden", p.active ? "bg-emerald-600" : "bg-rose-600")}>
              <button type="button" onClick={() => toggle(p)} data-testid={`status-petugas-card-${p.id}`} className="w-full p-5 text-left transition-transform active:scale-95 hover:bg-black/10">
                <p className="font-heading font-semibold truncate">{p.name}</p>
                <p className="text-xs text-white/80 truncate">{p.resort_name || "Tanpa resort"}</p>
                <p className="mt-4 text-sm font-bold" data-testid={`status-petugas-label-${p.id}`}>{p.active ? "AKTIF" : "TIDAK AKTIF"}</p>
              </button>
              <button type="button" onClick={() => setReset(p)} className="w-full border-t border-white/20 bg-black/15 hover:bg-black/25 py-2 text-xs font-semibold flex items-center justify-center gap-1.5" data-testid={`face-reset-${p.id}`}><ScanFace className="h-3.5 w-3.5" />Reset Wajah</button>
            </div>
          ))}
        </div>
      )}
      <ConfirmDialog open={Boolean(reset)} onOpenChange={(o) => !o && setReset(null)} title="Reset Wajah Absensi" confirmLabel="Ya, reset" onConfirm={doReset}
        description={reset && <>Hapus data wajah <b>{reset.name}</b>? Foto absen berikutnya akan menjadi wajah acuan baru.</>} />
    </div>
  );
}
